var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8011 11.7325L12.7079 14.8992C12.5311 15.0751 12.2964 15.1719 12.0469 15.1719C11.7965 15.1719 11.5611 15.0743 11.3827 14.896L8.19285 11.7264C8.0099 11.5442 7.7706 11.4531 7.53126 11.4531C7.29074 11.4531 7.05018 11.5451 6.86704 11.729C6.50165 12.0959 6.50277 12.6895 6.86966 13.0548L10.0582 16.2231C10.5893 16.7543 11.2957 17.0469 12.0469 17.0469C12.7981 17.0469 13.5044 16.7543 14.0356 16.2231C14.0372 16.2215 14.0387 16.2199 14.0403 16.2183L17.1364 13.0488C17.4999 12.6801 17.4956 12.0865 17.1269 11.723C16.7582 11.3595 16.1645 11.3637 15.8011 11.7325Z",
    fill: "#2D6CE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9375 11.4219L12.9375 2.9375C12.9375 2.41972 12.5178 2 12 2C11.4822 2 11.0625 2.41972 11.0625 2.9375L11.0625 11.4219C11.0625 11.9397 11.4822 12.3594 12 12.3594C12.5178 12.3594 12.9375 11.9397 12.9375 11.4219Z",
    fill: "#2D6CE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0625 16.3125C20.5447 16.3125 20.125 16.7322 20.125 17.25C20.125 18.2839 19.2839 19.125 18.25 19.125H5.75C4.71613 19.125 3.875 18.2839 3.875 17.25C3.875 16.7322 3.45528 16.3125 2.9375 16.3125C2.41972 16.3125 2 16.7322 2 17.25C2 19.3177 3.68225 21 5.75 21H18.25C20.3177 21 22 19.3177 22 17.25C22 16.7322 21.5803 16.3125 21.0625 16.3125Z",
    fill: "#2D6CE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPrimary);
export default __webpack_public_path__ + "static/media/download-primary.5cc35a31e0e4606c6714892729d5e7ab.svg";
export { ForwardRef as ReactComponent };